var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxiSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4802 11.951C13.7645 8.69015 8.21853 8.69015 4.50129 11.951L0.0703125 16.3949L5.57648 21.9613L5.56729 21.952L11.0336 16.4258L16.5475 22L22 16.4878L17.4772 11.951H17.4802Z",
    fill: "#163C45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52102 10.1058C8.23647 13.3851 13.7821 13.3851 17.4991 10.1058L21.9297 5.6368L16.4239 0.0389282L16.4331 0.0482709L10.9672 5.60566L5.45219 0L0 5.54337L4.52256 10.1058H4.52102Z",
    fill: "#91fdac"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxiSymbol);
export default __webpack_public_path__ + "static/media/axiSymbol.c45e68c1e36196811ebaf574e0f71a65.svg";
export { ForwardRef as ReactComponent };